/**
 * Allowed file types for request attachments in the NAM tenant.
 * Mirrors the legacy `packages/frontend` accept list to keep upload behavior
 * consistent across request creation and request details.
 */
export const NAM_REQUEST_ATTACHMENT_ACCEPT =
    'image/*,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.html,.docm,application/zip,application/x-zip-compressed,.DOC,.DOCX,.XLS,.XLSX,.PPT,.PPTX,.TXT,.CSV,.HTML,.DOCM';
